import { g as n } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const p = {
  name: "DtIconWhatsapp",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], f = ["fill"], m = ["id"];
function _(e, t, s, h, g, i) {
  return l(), d("svg", {
    "aria-label": s.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--whatsapp"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Whatsapp",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("path", {
      d: "M12.002 2.654h-.004C6.858 2.654 2.68 6.846 2.68 12c0 2.044.657 3.94 1.774 5.478l-1.162 3.471 3.583-1.148a9.221 9.221 0 0 0 5.127 1.545c5.14 0 9.318-4.193 9.318-9.346 0-5.153-4.179-9.346-9.318-9.346Z",
      fill: `url(#${e.uniqueID}a)`
    }, null, 8, f),
    t[1] || (t[1] = a("path", {
      d: "M17.426 15.851c-.225.637-1.118 1.165-1.83 1.32-.487.103-1.123.187-3.264-.704-2.74-1.138-4.503-3.928-4.64-4.11-.132-.18-1.107-1.477-1.107-2.818 0-1.342.679-1.995.953-2.275.225-.23.596-.335.953-.335.115 0 .219.006.312.01.274.012.411.028.592.462.225.543.772 1.884.838 2.022.066.138.132.325.04.506-.088.187-.165.27-.302.428-.138.16-.269.281-.406.451-.126.149-.268.308-.11.582.159.269.706 1.165 1.513 1.884 1.04.93 1.883 1.226 2.185 1.352.225.094.493.071.657-.104.209-.225.467-.6.729-.967.186-.264.421-.297.668-.203.252.087 1.584.747 1.857.884.274.138.455.203.521.319.066.115.066.659-.16 1.296Z",
      fill: "#FCFCFC"
    }, null, -1)),
    a("defs", null, [
      a("linearGradient", {
        id: `${e.uniqueID}a`,
        x1: "11.81",
        y1: "3.776",
        x2: "11.905",
        y2: "19.749",
        gradientUnits: "userSpaceOnUse"
      }, [...t[0] || (t[0] = [
        a("stop", { "stop-color": "#57D163" }, null, -1),
        a("stop", {
          offset: "1",
          "stop-color": "#23B33A"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, c);
}
const q = /* @__PURE__ */ u(p, [["render", _]]);
export {
  q as default
};
//# sourceMappingURL=whatsapp.js.map
